<script>
    import { getContext } from 'svelte';
    import Number from './util/Number.svelte';

    export let dataKey;
    const {
        scale,
        recallThreshold,
        precisionThreshold,
        writeChanges,
        computeMatches,
    } = getContext(dataKey);
</script>

<div class="col card">
    <b>Controls</b>
    <p>
        Filter matches with a recall of
        <Number
            bind:value={$recallThreshold}
            max="1"
            step="0.01"
            sensitivity="0.6"
            decimals="2"
        />
        and a precision of
        <Number
            bind:value={$precisionThreshold}
            max="1"
            step="0.01"
            sensitivity="0.6"
            decimals="2"
        />.
    </p>
    <div class="row" style="width:100%;">
        <button on:click={computeMatches}>match</button>
        <button on:click={writeChanges} disabled="true">save</button>
    </div>
</div>

<style>
    button {
        flex-shrink: 1;
        flex-grow: 1;
        font-size: 12px;
        padding: 2px;
    }
</style>
